/*
 *  Copyright 2017-2026 Jason Schindler
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

/**
 * @summary Browser entry point for Pubst.
 *
 * @description
 * This file is the entry point for the browser IIFE bundle.
 * It creates a new Pubst instance and attaches it to the
 * global `window` object as `window.pubst`.
 *
 * Consumers may call `await pubst.configure(...)` to customize
 * the instance before use.  If no configuration changes are needed,
 * the instance is ready to use immediately.
 */

import Pubst from './Pubst.js';

window.pubst = new Pubst();
